import { render, staticRenderFns } from "./updateSlug.vue?vue&type=template&id=1becc410&"
import script from "./updateSlug.vue?vue&type=script&lang=js&"
export * from "./updateSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports